<template>
  <main>
    <!-- Confirm Modal -->
    <div
      v-if="showConfirmBatchOperationModal"
      id="confirmActionOverlay"
      class="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center"
    >
      <div class="">
        <div class="flex relative items-center justify-center bg-gray-100">
          <div class="w-full max-w-lg px-6 py-9 bg-white rounded-lg shadow-lg">
            <button
              class="absolute top-0 right-0 mt-2 mr-2 text-gray-500 hover:text-gray-700"
              @click="closeConfirmModal()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <div class="flex justify-center mb-4">
              <div
                class="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full"
              >
                <img
                  v-if="isTurnOnSelected"
                  src="@/assets/green-thumb-up.png"
                  alt=""
                />
                <img
                  v-if="isTurnOffSelected"
                  src="@/assets/yellow-thumb-down.png"
                  alt=""
                />
              </div>
            </div>
            <h2
              class="text-center mx-auto w-2/3 text-xl font-semibold text-gray-900 mb-2"
            >
              Do you want to turn
              <span v-if="isTurnOnSelected">on</span>
              <span v-if="isTurnOffSelected">off</span>
              auto deductions for these merchants?
            </h2>
            <p class="text-center mx-auto w-4/6 text-sm text-gray-600 mb-6">
              Please note that this action will
              <span v-if="isTurnOnSelected">initiate</span>
              <span v-if="isTurnOffSelected">stop</span>
              automatic deductions from the selected merchants' Traction
              wallets/net fee due.
            </p>
            <div class="flex space-x-4">
              <button
                @click="batchUpdateDeductions()"
                class="uppercase flex-1 bg-blue-800 flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
              >
                <div class="text-xs text-center w-full">
                  Turn
                  <span v-if="isTurnOnSelected">on</span>
                  <span v-if="isTurnOffSelected">off</span>
                  auto deductions
                </div>
              </button>
              <button
                @click="closeConfirmModal()"
                class="uppercase flex-1 bg-red-800 flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
              >
                <div class="text-xs text-center w-full">Cancel</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Confirm Modal -->

    <!-- Delete Confirm Modal -->
    <div
      v-if="showDeleteConfirmModal"
      id="deleteConfirmOverlay"
      class="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center"
    >
      <div class="">
        <div class="flex relative items-center justify-center bg-gray-100">
          <div class="w-full max-w-lg px-6 py-9 bg-white rounded-lg shadow-lg">
            <button
              class="absolute top-0 right-0 mt-2 mr-2 text-gray-500 hover:text-gray-700"
              @click="showDeleteConfirmModal = false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <div class="flex justify-center mb-4">
              <div
                class="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full"
              >
                <svg
                  class="w-8 h-8 text-red-500"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
            </div>
            <h2
              class="text-center mx-auto w-2/3 text-xl font-semibold text-gray-900 mb-2"
            >
              Are you sure you want to delete this auto deduction setting?
            </h2>
            <div class="flex space-x-4">
              <button
                @click="deleteRecord(currentId)"
                class="uppercase flex-1 bg-red-800 flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
              >
                <div class="text-xs text-center w-full">YES</div>
              </button>
              <button
                @click="showDeleteConfirmModal = false"
                class="uppercase flex-1 bg-gray-800 flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
              >
                <div class="text-xs text-center w-full">NO</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Delete Confirm Modal -->

    <!-- Download Report Modal -->
    <div
      v-if="showDownloadReportModal"
      id="downloadReportModal"
      class="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center"
    >
      <div class="">
        <div class="flex relative items-center justify-center bg-gray-100">
          <div class="w-full max-w-lg px-6 py-9 bg-white rounded-lg shadow-lg">
            <button
              class="absolute top-0 right-0 mt-2 mr-2 text-gray-500 hover:text-gray-700"
              @click="showDownloadReportModal = false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <h2
              class="text-left mx-auto text-xl font-semibold text-gray-900 mb-2"
            >
              Download Deduction Report
            </h2>
            <div class="mb-4">
              <label class="text-xs font-bold text-gray-400"
                >Select Report Type</label
              >
              <select
                v-model="downloadReportCriteria.deductionType"
                class="form-input border-opacity-25 border-black w-full"
              >
                <option value="" disabled selected>Select an Option</option>
                <option value="general">General Deduction Report</option>
                <option value="saving">Savings Deduction Report</option>
                <option value="loan">Loan Repayment Deduction Report</option>
              </select>
            </div>
            <div class="mb-4 flex flex-col">
              <label class="text-xs font-bold text-gray-400">Select Date</label>
              <date-picker
                v-model="downloadReportCriteria.date"
                format="YYYY-MM-DD"
                type="date"
                valueType="format"
                class="w-full"
                :disabled-date="(date) => date >= moment().toDate()"
              ></date-picker>
            </div>
            <div class="flex justify-start">
              <button
                @click="downloadReport"
                id="downloadReport"
                :disabled="!canDownload"
                class="uppercase bg-blue-800 flex shadow my-2 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
                :class="{ 'opacity-50': !canDownload }"
              >
                <div class="text-xs text-center w-full">Download</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Download Report Modal -->

    <Loading v-if="isLoading"></Loading>
    <div v-else>
      <div v-if="!error">
        <h1 class="text-2xl font-bold">Deduction Management Portal</h1>
        <div class="flex mt-12 gap-x-2 items-center">
          <input
            type="text"
            class="inline-block px-2 ring-2 outline-none ring-blue-500 rounded-sm ml-2 w-64 text-sm py-2"
            name=""
            placeholder="Search for business name or email address"
            id=""
            v-model="search"
          />
          <button
            :disabled="!search"
            @click="
              showSearchOptions = false;
              currentPage = 1;
              fetchRecords();
            "
            :class="{ 'bg-blue-900': search, 'bg-gray-500': !search }"
            class="uppercase flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
          >
            <span class="flex-1 px-4">Search</span>
          </button>
          <button
            v-if="search"
            @click="
              showSearchOptions = false;
              search = '';
              currentPage = 1;
              resetSearchOptions();
              fetchRecords();
            "
            class="uppercase flex border-default shadow m-2 focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
          >
            <span class="flex-1 px-4">Clear</span>
          </button>
          <div class="flex-1"></div>
          <button
            @click="$router.push({ name: 'AutoDeductionSettings' })"
            class="uppercase bg-blue-800 flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
          >
            <span class="flex-1 px-4">Auto Deductions Settings</span>
          </button>
          <button
            @click="showDownloadReportModal = true"
            class="uppercase bg-blue-800 flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
          >
            <span class="flex-1 px-4">Download Deduction Report</span>
          </button>
        </div>
        <div
          v-if="responseMessage"
          class="mt-6 w-full lg:w-1/2 border border-green-300 bg-blue-100 px-4 py-3 rounded-md text-sm font-medium"
        >
          {{ responseMessage }}
        </div>
        <div
          v-if="errorMessage"
          class="mt-6 w-full lg:w-1/2 border border-green-300 bg-red-100 px-4 py-3 rounded-md text-sm font-medium"
        >
          {{ errorMessage }}
        </div>
        <div class="mt-6 flex relative flex-row">
          <button
            @click="showSearchOptions = !showSearchOptions"
            class="uppercase w-64 flex shadow m-2 bg-blue-600 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
          >
            <span class="flex-1 px-4">Filter by Status</span>
            <img src="@/assets/images/filter-icon.png" alt="" />
          </button>
          <div
            v-if="showSearchOptions"
            class="absolute shadow-md top-13 z-10 bg-white w-64 mx-2 border rounded-b-lg text-sm py-3"
          >
            <div
              class="px-2 py-2 border-b border-gray-200"
              v-for="(option, index) in searchOptionsList"
              :key="index"
            >
              <div class="flex gap-x-2">
                <input
                  type="checkbox"
                  :checked="option.selected"
                  @change="selectOption(index)"
                  name=""
                  class=""
                />
                <span>{{ option.label }}</span>
              </div>
            </div>
            <div class="p-2">
              <button
                @click="
                  showSearchOptions = false;
                  fetchRecords();
                "
                class="uppercase shadow w-full bg-blue-900 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
              >
                <span class="px-4">Apply</span>
              </button>
            </div>
          </div>
          <div class="relative">
            <button
              @click="
                showMultiSelectOptions = !showMultiSelectOptions;
                showMoreOptionLabel = false;
              "
              @mouseover="showMoreOptionLabel = true"
              @mouseout="showMoreOptionLabel = false"
              class="uppercase w-auto bg-gray-100 shadow m-2 text-black focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
            >
              <img src="@/assets/vertical-more.png" class="w-1" />
              <div
                id="moreOption"
                v-show="showMoreOptionLabel"
                class="absolute capitalize top-12 w-auto whitespace-nowrap left-10 bg-gray-200 p-2 text-xs rounded font-medium"
              >
                More Actions
              </div>
            </button>
            <div
              v-if="showMultiSelectOptions"
              id="select-options"
              class="absolute shadow-md top-13 z-10 bg-white w-64 mx-2 border rounded-b-lg text-sm py-3"
            >
              <div
                class="px-2 py-2 border-b border-gray-200"
                v-for="(option, index) in multiSelectOptions"
                :key="index"
              >
                <button
                  class="flex gap-x-2 px-2 py-1 hover:bg-gray-200"
                  @click="toggleAction(option.value, index)"
                  :class="{
                    'opacity-50':
                      (option.value === 'turnon' ||
                        option.value === 'turnoff') &&
                      batchSelectedIds < 1,
                  }"
                >
                  <span>{{ option.label }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-12" style="max-height: 600px; overflow: scroll">
          <table
            id="accountList"
            class="shadow-lg bg-white w-full relative border-collapse"
          >
            <tr class="header">
              <th>
                <!-- <input type="checkbox" class="" /> -->
              </th>
              <th
                colspan="2"
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Business Id
              </th>
              <th
                colspan="2"
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Business Name
              </th>
              <th
                colspan="2"
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Email Address
              </th>
              <th
                colspan="2"
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Settlement Preference
              </th>
              <th
                colspan="2"
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Deduction Amount/Percentage
              </th>
              <th
                colspan="2"
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Deduction Type
              </th>
              <!-- <th
                colspan="2"
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Deduction Frequency
              </th> -->
              <th
                colspan="2"
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Status
              </th>
              <th
                colspan="2"
                style="text-align: center"
                class="bg-blue-100 text-sm border whitespace-nowrap px-8 py-2"
              >
                Actions
              </th>
            </tr>
            <tr
              v-for="(account, index) in accounts"
              :key="index"
              class="list text-xs"
            >
              <td>
                <input type="checkbox" v-model="account.selected" class="" />
              </td>
              <td colspan="2" class="border">
                {{ account.businessId }}
              </td>
              <td colspan="2" class="border capitalize">
                {{ account.businessName }}
              </td>
              <td colspan="2" class="border">{{ account.businessEmail }}</td>
              <td colspan="2" class="border capitalize">
                {{ relabel(account.settlementType) }}
              </td>
              <td colspan="2" class="border">
                <span v-if="account.amountType === 'fixed'">
                  <span>&#8358;</span>
                </span>
                {{ account.amount }}
                <span v-if="account.amountType === 'fixed'"></span>
                <span v-else>%</span>
              </td>
              <td colspan="2" class="border">{{ relabel(account.type) }}</td>
              <!-- <td colspan="2" class="border capitalize">
                {{ account.frequency }}
              </td> -->
              <td colspan="2" class="border capitalize">
                {{ account.status }}
              </td>
              <td
                colspan="2"
                class="border flex gap-x-1 flex-row justify-evenly"
              >
                <button @click="toggleStatus(account)" class="w-12">
                  <img
                    class="w-12 inline-block"
                    v-if="account.status === 'on'"
                    src="@/assets/toggle-on.png"
                    alt=""
                  />
                  <img
                    class="w-12 inline-block"
                    v-else
                    src="@/assets/toggle-off.png"
                    alt=""
                  />
                </button>
                <button
                  class="border-default bg-white px-2 py-1 rounded"
                  @click="gotoDetail(account)"
                >
                  Edit
                </button>
                <button
                  class="bg-red-500 text-white px-2 py-1 rounded"
                  @click="confirmDelete(account)"
                >
                  Delete
                </button>
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-3">
          <button
            @click="prevPage(currentPage)"
            :disabled="currentPage === 1 ? isDisabled : !isDisabled"
            class="uppercase shadow ml-3 hover:bg-blue-900 focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-8 rounded"
            :class="
              currentPage === 1
                ? 'bg-blue-50 text-black'
                : 'bg-blue-900 text-white'
            "
          >
            &laquo; Prev
          </button>
          <button
            @click="nextPage(currentPage)"
            class="float-right uppercase shadow ml-3 hover:bg-blue-900 bg-blue-900 focus:shadow-outline focus:outline-none text-white text-xs font-bold py-3 px-8 rounded"
          >
            Next &raquo;
          </button>
        </div>
      </div>
      <div v-else class="border p-12 rounded-lg mx-12 mt-12">
        <h3 class="text-2xl mb-2 font-bold">Error Occured</h3>
        <p>
          {{ error }}
        </p>
        <button
          @click="clearAndSearch(true)"
          class="uppercase flex shadow my-2 bg-blue-900 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
        >
          Clear
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Loading from "./general-components/Loading.vue";
export default {
  data() {
    return {
      currentId: "",
      showMoreOptionLabel: false,
      showConfirmBatchOperationModal: false,
      showDeleteConfirmModal: false,
      showDownloadReportModal: false,
      downloadReportCriteria: {
        deductionType: "",
        date: "",
      },
      moment,
      error: null,
      isLoading: false,
      currentPage: 1,
      isDisabled: true,
      search: "",
      accounts: [],
      selected: [],
      selectedWhitelist: [],
      searchRange: {
        limit: 10,
        page: 0,
      },
      searchOptionsList: [
        {
          value: null,
          selected: true,
          label: "All Records",
        },
        {
          value: "pending",
          selected: false,
          label: "Pending Records",
        },
        {
          value: "on",
          selected: false,
          label: "On Records",
        },
        {
          value: "off",
          selected: false,
          label: "Off Records",
        },
      ],
      multiSelectOptions: [
        {
          value: "all",
          selected: false,
          label: "Select All",
        },
        {
          value: "turnon",
          selected: false,
          label: "Turn on All Auto Deductions",
        },
        {
          value: "turnoff",
          selected: false,
          label: "Turn off All Auto Deductions",
        },
        {
          value: "none",
          selected: false,
          label: "Unselect All",
        },
      ],
      showSearchOptions: false,
      showMultiSelectOptions: false,
      responseMessage: "",
      errorMessage: "",
    };
  },
  components: {
    Loading,
    DatePicker,
  },
  async created() {
    this.fetchRecords();
  },
  methods: {
    relabel(stringValue) {
      if (stringValue.toLowerCase() === "saving" || stringValue.toLowerCase() === "savings") {
        return "Savings Deduction";
      } else if (stringValue.toLowerCase() === "loan") {
        return "Loan Repayment";
      } else if (stringValue.toLowerCase() === "lease") {
        return "Terminal lease payment";
      } else if (stringValue.toLowerCase() === "sameday") {
        return "End of the day";
      } else if (stringValue.toLowerCase() === "instant") {
        return "Instant";
      } else {
        return "";
      }
    },
    clearAndSearch(clearText = false) {
      if (clearText) {
        this.currentPage = 1;
        this.search = "";
        this.searchOptionsList = this.searchOptionsList.map((option, i) => {
          option.selected = option.label === "All Records" ? true : false;
          return option;
        });
      }
      this.fetchRecords();
    },
    selectOption(index) {
      this.searchOptionsList = this.searchOptionsList.map((option, i) => {
        if (i === index) {
          option.selected = true;
        } else {
          option.selected = false;
        }
        return option;
      });
    },
    frontEndFilter(accounts = []) {
      const status = this.selectedRecordType.value;
      const search = this.search;
      const filteredAccounts = accounts.filter((account) => {
        const matchesStatus = status ? account.status === status : true;
        const matchesSearch =
          account.businessEmail.toLowerCase().includes(search.toLowerCase()) ||
          account.businessName.toLowerCase().includes(search.toLowerCase());
        return matchesStatus && matchesSearch;
      });
      return filteredAccounts;
    },
    async fetchRecords(searchProperties = this.searchParameters) {
      this.isLoading = true;
      this.errorMessage = ''
      let response = await this.$store.dispatch(
        "GET_DEDUCTIONS",
        searchProperties
      );
      console.log("deductions", response);
      this.accounts = (response.data || []).map((account) => ({
        ...account,
        selected: false,
      }));

      if (response.status) {
        this.isLoading = false;
        this.error = null;
      } else {
        this.error = response.message;
        this.isLoading = false;
      }
    },
    async prevPage() {
      this.currentPage -= 1;
      this.fetchRecords();
    },
    async nextPage() {
      this.currentPage += 1;
      this.fetchRecords();
    },
    gotoDetail(account) {
      this.$router.push({
        name: "AutoDeductionSettings",
        params: {
          _id: account._id,
          amount: account.amount,
          amountType: account.amountType,
          createdAt: account.createdAt,
          dayOfWeek: account.dayOfWeek,
          frequency: account.frequency,
          loanDiskId: account.loanDiskId,
          startAt: account.startAt,
          totalAmount: account.totalAmount,
          type: account.type,
          businessEmail: account.businessEmail,
          businessId: account.businessId,
          businessName: account.businessName,
          deductionMethod: account.deductionMode,
          numberOrPercentage: account.amountType === 'fixed' ? true : false
        },
      });
    },
    async toggleStatus(account) {
      const intendedStatus = account.status === "on" ? "off" : "on";
      this.isLoading = true;
      this.errorMessage = ''
      this.responseMessage = "";
      try {
        const response = await this.$store.dispatch("TOGGLE_DEDUCTION_STATUS", {
          id: account._id,
          intendedStatus,
        });
        if (response.status) {
          this.fetchRecords();
        } else {
          this.errorMessage = response.error;
        }
      } catch (error) {
        this.responseMessage = error.message;
      } finally {
        this.isLoading = false;
      }
    },
    canCarryOutBatchOperation(option) {
      // debugger;
      return (
        (option.value === "turnon" || option.value === "turnoff") &&
        this.batchSelectedIds.length === 0
      );
    },
    closeConfirmModal() {
      this.showConfirmBatchOperationModal = false;
      this.resetMultiSelectOptions();
    },
    resetMultiSelectOptions() {
      this.multiSelectOptions = this.multiSelectOptions.map((option) => ({
        ...option,
        selected: false,
      }));
    },
    resetSearchOptions() {
      this.searchOptionsList = this.searchOptionsList.map((option) => {
        if (option.label === "All Records") {
          option.value = null;
          option.selected = true;
        } else {
          option.selected = false;
        }
        return option;
      });
    },
    batchUpdateDeductions() {
      this.isLoading = true;
      this.errorMessage = ''
      let status;
      if (this.isTurnOnSelected) {
        status = "on";
      }
      if (this.isTurnOffSelected) {
        status = "off";
      }
      const payload = {
        status,
        batchOfIds: {
          ids: this.batchSelectedIds,
        },
      };
      this.$store
        .dispatch("BATCH_UPDATE_DEDUCTIONS", payload)
        .then((response) => {
          if (response.status) {
            this.showConfirmBatchOperationModal = false;
            this.isLoading = false;
            this.responseMessage = response.message;
            this.resetMultiSelectOptions();
            this.fetchRecords();
          } else {
            this.isLoading = false;
            this.errorMessage = response.error;
            this.resetMultiSelectOptions();
          }
        });
    },
    toggleAction(value, index) {
      // debugger;
      if (value === "all") {
        this.accounts.forEach((account) => (account.selected = true));
        this.multiSelectOptions[index].selected =
          !this.multiSelectOptions[index].selected;
      } else if (value === "none") {
        this.resetMultiSelectOptions();
        this.accounts.forEach((account) => (account.selected = false));
      } else if (value === "turnon" || value === "turnoff") {
        if (this.batchSelectedIds.length > 0) {
          this.multiSelectOptions[index].selected =
            !this.multiSelectOptions[index].selected;
          this.showConfirmBatchOperationModal = true;
        }
      }
    },
    confirmDelete(account) {
      this.currentId = account._id;
      this.showDeleteConfirmModal = true;
    },
    async downloadReport() {
      try {
        this.isLoading = true;
        this.errorMessage = ''
        this.showDownloadReportModal = false;
        const response = await this.$store.dispatch(
          "DOWNLOAD_DEDUCTION_REPORT",
          {
            type: this.downloadReportCriteria.deductionType,
            date: this.downloadReportCriteria.date,
          }
        );
        if (response.status) {
          this.isLoading = false;
          const link = document.createElement("a");
          link.href = response.data.link;
          link.download = "deduction_report.csv";
          link.click();
          this.responseMessage = response.message;
        } else {
          this.isLoading = false;
          this.showDownloadReportModal = false;
          this.errorMessage = response.error;
        }
      } catch (error) {
        this.responseMessage =
          "An error occurred while downloading the report.";
      }
    },
    deleteRecord(id) {
      // Implement the delete logic here
      this.showDeleteConfirmModal = false;
      this.$store.dispatch("DELETE_DEDUCTION", id).then((response) => {
        if (response.status) {
          this.showDeleteConfirmModal = false;
          this.responseMessage = "Successfully Deleted";
          this.fetchRecords();
        } else {
          this.showDeleteConfirmModal = false;
          this.errorMessage = response.error;
        }
      });
    },
  },
  computed: {
    isTurnOnSelected() {
      return this.multiSelectOptions.some(
        (option) => option.value === "turnon" && option.selected
      );
    },
    isTurnOffSelected() {
      return this.multiSelectOptions.some(
        (option) => option.value === "turnoff" && option.selected
      );
    },
    batchSelectedIds() {
      return this.accounts
        .filter((account) => account.selected)
        .map((account) => account._id);
    },
    selectedRecordType() {
      return (
        this.searchOptionsList.find((item) => item.selected === true) || {
          value: null,
        }
      );
    },
    searchParameters() {
      const criteria = {
        limit: 10,
        page: this.currentPage,
      };
      if (this.search) {
        criteria["search"] = this.search;
      }
      if (this.selectedRecordType.value) {
        criteria["status"] = this.selectedRecordType.value;
      }
      return criteria;
    },
    anyAccountSelected() {
      return this.accounts.some((account) => account.selected);
    },
    canDownload() {
      return (
        this.downloadReportCriteria.deductionType &&
        this.downloadReportCriteria.date
      );
    },
  },
};
</script>

<style lang="postcss" scoped>
.form-input {
  border-width: 1px;
  @apply w-full rounded px-2 py-3 text-xs;
}
table {
  border-collapse: separate;
  border-spacing: 0;
  min-width: 350px;
}
table tr th:last-child {
  border-right: 1px solid rgb(241, 241, 241);
}
table tr th,
table tr td {
  /* border-right: 1px solid #bbb; */
  border-bottom: 1px solid rgb(238, 238, 238);
  padding: 10px;
}
table tr th:first-child,
table tr td:first-child {
  /* border-right: 1px solid rgb(223, 223, 223); */
  border-left: 1px solid rgb(241, 241, 241);
}
table tr th {
  background: rgb(255, 255, 255);
  border-top: 1px solid rgb(241, 241, 241);
  text-align: left;
}
table tr td {
  background: #f0f6fd;
}
/* top-left border-radius */
table tr:first-child th:first-child {
  border-top-left-radius: 6px;
}

/* top-right border-radius */
table tr:first-child th:last-child {
  border-top-right-radius: 6px;
}

/* bottom-left border-radius */
table tr:last-child td:first-child {
  border-bottom-left-radius: 6px;
}

/* bottom-right border-radius */
table tr:last-child td:last-child {
  border-bottom-right-radius: 6px;
}
</style>